import * as React from "react";

import { YouTube } from "../Components/YouTube";

export function BillWurtzPage(): JSX.Element {
    return (
        <div style={{ textAlign: "center" }}>
            <h1>recommended bill wurtz content:</h1>
            <p>
                <YouTube
                    videoId="Su0CRL_eA_8"
                    playlist="9oYs_hSlfy0,xlcnR9daQD0,fW49Q6DMlhA,4q1Zs3vbX8M,N-_Xzh3rWpg,sNx57atloH8,GUlHEPWUk4o,HRSxg49Y-WI"
                />
            </p>
        </div>
    );
}
